import React, { useEffect, useState } from "react";
import { useLang } from "@/i18n";
import { OrnateHeartDivider } from "./FloralOrnaments";

function calc(target) {
    const now = new Date().getTime();
    const diff = Math.max(0, target - now);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return { days, hours, minutes, seconds };
}

function Box({ value, label, testId }) {
    const str = String(value).padStart(2, "0");
    return (
        <div
            data-testid={testId}
            className="flex flex-col items-center justify-center rounded-xl border border-[var(--wd-border)] bg-white/60 backdrop-blur-sm px-3 py-4 md:px-5 md:py-5 min-w-[68px] md:min-w-[90px] shadow-sm"
        >
            <span className="wd-heading text-3xl md:text-5xl text-[var(--wd-primary)] tabular-nums">
                {str}
            </span>
            <span className="wd-label mt-1 text-[10px] md:text-xs text-[var(--wd-text-muted)]">
                {label}
            </span>
        </div>
    );
}

export default function CountdownTimer({ dateIso }) {
    const { t } = useLang();
    const target = new Date(dateIso).getTime();
    const [parts, setParts] = useState(() => calc(target));

    useEffect(() => {
        const id = setInterval(() => setParts(calc(target)), 1000);
        return () => clearInterval(id);
    }, [target]);

    return (
        <section data-testid="countdown-section" className="py-16 px-6 text-center">
            <h3 className="wd-heading text-3xl md:text-4xl text-[var(--wd-primary)] mt-2">
                {t("countingEveryMoment")}
            </h3>
            <div className="mt-8 max-w-md mx-auto flex justify-center"><OrnateHeartDivider /></div>
            <div className="mt-10 flex items-center justify-center gap-2 md:gap-4 flex-wrap max-w-lg mx-auto" dir="ltr">
                <Box value={parts.days} label={t("days")} testId="countdown-days" />
                <Box value={parts.hours} label={t("hours")} testId="countdown-hours" />
                <Box value={parts.minutes} label={t("minutes")} testId="countdown-minutes" />
                <Box value={parts.seconds} label={t("seconds")} testId="countdown-seconds" />
            </div>
        </section>
    );
}
